import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import memoize from 'memoize-one';
import { FetchError } from './types';
export const fetchMetadata = async (url, params, timeout, signal) => {
  var _params$userInfo, _params$userInfo2, _params$tenantInfo, _params$tenantInfo2;
  const requestAbortController = createRequestAbortController(timeout, signal);
  const corsOptions = getCorsForUrl(url);
  const metadataUrl = url + '?' + new URLSearchParams({
    product: `${params.product}`,
    userId: `${((_params$userInfo = params.userInfo) === null || _params$userInfo === void 0 ? void 0 : _params$userInfo.userId) || ''}`,
    userIdType: `${((_params$userInfo2 = params.userInfo) === null || _params$userInfo2 === void 0 ? void 0 : _params$userInfo2.userIdType) || ''}`,
    tenantId: `${((_params$tenantInfo = params.tenantInfo) === null || _params$tenantInfo === void 0 ? void 0 : _params$tenantInfo.tenantId) || ''}`,
    tenantIdType: `${((_params$tenantInfo2 = params.tenantInfo) === null || _params$tenantInfo2 === void 0 ? void 0 : _params$tenantInfo2.tenantIdType) || ''}`
  }).toString();
  const response = await fetch(metadataUrl, _objectSpread({
    method: 'GET',
    signal: requestAbortController.signal
  }, corsOptions));

  // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
  if (response.status !== 200) {
    throw new FetchError(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
  }
  return response;
};
const createRequestAbortController = (timeout, signal) => {
  const abortController = new AbortController();
  setTimeout(() => {
    abortController.abort();
  }, timeout || 30000);
  signal === null || signal === void 0 || signal.addEventListener('abort', () => {
    abortController.abort();
  });
  return abortController;
};

// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const getCorsForUrl = memoize(url => {
  const origin = new URL(url).origin;
  if (origin === location.origin) {
    return {};
  } else {
    return {
      mode: 'cors',
      credentials: 'include'
    };
  }
});